import { Pipe, PipeTransform } from '@angular/core'
import { isNumber } from '../utils/type-checks'

const kb = 1000
const mb = kb * kb
const gb = kb * mb

@Pipe({
    name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
    transform(size: unknown): string {
        if (size === undefined || size === null || !isNumber(size)) return ''

        if (size >= gb) {
            return `${(size / gb).toFixed(2)} GB`
        }
        if (size >= mb) {
            return `${(size / mb).toFixed(2)} MB`
        }
        if (size >= kb) {
            return `${(size / kb).toFixed(2)} KB`
        }
        return `${size} B`
    }
}
